// reward link
export const SET_IS_REDEEMED = 'SET_IS_REDEEMED'

export const SET_REWARD_LINK_AVAILABLE_AMOUNT =
  'SET_REWARD_LINK_AVAILABLE_AMOUNT'

export const SET_BALANCE = 'SET_BALANCE'

export const SET_REWARD_LINK = 'SET_REWARD_LINK'

// app

export const APP_SET_DISCLAIMER = 'APP_SET_DISCLAIMERS'

// cart

export const ADD_CART_ITEM = 'ADD_CART_ITEM'

export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM'

export const UPDATE_ITEM_VALUE = 'UPDATE_ITEM_VALUE'

export const RESET_CART = 'RESET_CART'

export const SET_CART_EXTERNAL_REF_ID = 'SET_CART_EXTERNAL_REF_ID'

export const SET_SHOW_CART = 'SET_SHOW_CART'

export const INIT_EXTERNAL_REF_ID = 'INIT_EXTERNAL_REF_ID'

// order

export const SET_IS_PLACING_ORDER = 'SET_IS_PLACING_ORDER'

export const SET_ORDER_CONFIRMATION = 'SET_ORDER_CONFIRMATION'

export const SET_ORDER_VALIDATION = 'SET_ORDER_VALIDATION'

// recipient data

export const SET_SPECIFIC_RL_RECIPIENT_DATA = 'SET_SPECIFIC_RL_RECIPIENT_DATA'

export const SET_RECIPIENT_DATA = 'SET_RECIPIENT_DATA'

export const UPDATE_DIGITAL_RECIPIENT_DATA = 'UPDATE_DIGITAL_RECIPIENT_DATA'

export const UPDATE_PHYSICAL_RECIPIENT_DATA = 'UPDATE_PHYSICAL_RECIPIENT_DATA'

// catalog

export const SET_CATALOG = 'SET_CATALOG'

export const SET_CATALOG_SEARCH_PARAMS = 'SET_CATALOG_SEARCH_PARAMS'

export const SET_SEARCH_IS_VISIBLE = 'SET_SEARCH_IS_VISIBLE'

// analytics

export const SET_LONGEST_SCROLL = 'SET_LONGEST_SCROLL'

// feedback

export const ADD_PARTICIPATED_SURVEY = 'ADD_PARTICIPATED_SURVEY'

// redemption history

export const ADD_REDEMPTION_HISTORY_ITEMS = 'ADD_REDEMPTION_HISTORY_ITEMS'

export const SET_REFERENCE_LINE_ITEM_ID = 'SET_REFERENCE_LINE_ITEM_ID'

export const SET_NO_MORE_ITEMS = 'SET_NO_MORE_ITEMS'

// wallet

export const SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED'

export const SET_RECIPIENT_DETAILS = 'SET_RECIPIENT_DETAILS'

export const SET_SIGNUP_COMPLETE = 'SET_SIGNUP_COMPLETE'

// Direct Payments

export const SET_DIRECT_PAYMENT_AMOUNT = 'SET_DIRECT_PAYMENT_AMOUNT'

export const SET_DIRECT_PAYMENT_TYPE = 'SET_DIRECT_PAYMENT_TYPE'

export const SET_DIRECT_PAYMENT_SESSION_ID = 'SET_DIRECT_PAYMENT_SESSION_ID'

export const SET_DIRECT_PAYMENT_UTID = 'SET_DIRECT_PAYMENT_UTID'
